import { EzEnumeration2 } from '/ezlibrary/enums/EzEnumeration2.js';

/**
 * @class
 * @extends {EzEnumeration2}
 * @description
 * A template for an ezClocker enumeration class.
 * ------------------------------------------------------------------
 * Import into non-enumeration classes with:
 *      import {
 *          // ... other enumeration classes ...
 *          EzParamName
 *      } from '/ezlibrary/enums/EzEnumerations.js';
 * ------------------------------------------------------------------
 * Import into other enumeration classes or classes that cannot
 * import EzEnumerations:
 *      import { EzParamName } from '/ezlibrary/enums/EzParamName.js';
 * ------------------------------------------------------------------
 * Access static reference:
 *      Inside class: EzParamName.{method or property}
 *      Outside of class: EzParamName.{method or property}
 * ------------------------------------------------------------------
 */
export class EzParamName extends EzEnumeration2 {
    /**
     * @private @field
     * Stores the singleton instance of this enumeration class.
     * @type {EzParamName}
     */
    static #ezEnumerationSingleton = null;

    /**
     * @static
     * Static Initialization
     */
    static {
        if (null == this.#ezEnumerationSingleton) {
            this.#ezEnumerationSingleton = new EzParamName(
                // Enum property names
                [
                    'UNKNOWN',
                    'DEBUG',
                    'SHOW_IDS',
                    'UTM_SOURCE',
                    'UTM_CAMPAIGN',
                    'UTM_MEDIUM',
                    'TOKEN',
                    'EMPLOYER',
                    'ERROR',
                    'EMAIL',
                    'INDUSTRY',
                    'REVISION',
                    'USER_NAME',
                    'NAME',
                    'EMPLOYER_NAME',
                    'SOURCE',
                    'INVITE_TOKEN',
                    'HACKED'
                ],
                // Enum property values for each enum property name as an array
                // Enter null if the values are equal to the names
                [
                    'UNKNOWN',
                    // DEBUG
                    'debug',
                    // SHOW_IDS
                    'show-ids',
                    // UTM_SOURCE
                    'utm_source',
                    // UTM_COMPAIGN
                    'utm_campaign',
                    // UTM_MEDIUM
                    'utm_medium',
                    // TOKEN
                    'token',
                    // EMPLOYER
                    'employer',
                    // ERROR
                    'error',
                    // EMAIL
                    'email',
                    // INDUSTRY
                    'i',
                    // REVISION
                    'v',
                    // USER_NAME
                    'un',
                    // NAME
                    'name',
                    // EMPLOYER_NAME
                    'employer-name',
                    // SOURCE
                    'source',
                    // INVITE_TOKEN
                    'inviteToken',
                    // HACKED
                    'hAk3ziD'
                ],
                // Optional array of additional data for eac enumeration property.
                // Enter null if not needed.
                null);
        }
    }
}